module.exports = __webpack_public_path__ + "static/OCRA-0da0345bc493f1dfc676ac7df4c2960b.ttf";